export default function editLocomotive() {
  return this.$store.dispatch('locomotive/editLocomotive', {
    id: this.model.id,
    sideNumber: this.model.sideNumber,
    company: this.model.company['@id'],
  });
}
